export default __webpack_public_path__ + "static/media/earPlugs.e2242974.jpg";